<template>
  <div class="box7">
    <pageTitle title="博学谷AI运维&nbsp;&nbsp;五大优势" />
    <ul class="content">
      <li>
        <img src="../../../assets/coursePage/linux/box7/01.png"/>
        <h1>全行业项目库</h1>
        <p>多元化的业务场景<br/>满足各行业的运维需求</p>
      </li>
      <li>
        <img src="../../../assets/coursePage/linux/box7/02.png"/>
        <h1>场景化教学模式</h1>
        <p>50+典型运维场景<br/>积累真实经验</p>
      </li>
      <li>
        <img src="../../../assets/coursePage/linux/box7/03.png"/>
        <h1>AI大模型全程助力</h1>
        <p>辅助运维开发<br/> 学会利用AI高效工作</p>
      </li>
      <li>
        <img src="../../../assets/coursePage/linux/box7/04.png"/>
        <h1>云端教学环境</h1>
        <p>云端教学环境+对标头部云厂商<br/>资深认证课，掌握云端运维技能</p>
      </li>
      <li>
        <img src="../../../assets/coursePage/linux/box7/05.png"/>
        <h1>100%还原真实运维流程</h1>
        <p>引入运维工单系统<br/>全面模拟企业真实运维流程</p>
      </li>
      <li class="last">
        <img src="../../../assets/coursePage/linux/box7/img01.png"/>
      </li>
    </ul>
   
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box7 {
  background: linear-gradient( 318deg, #EBF6FF 0%, #FFFFFF 100%);
  padding: 60px 0 40px;
  .content{
    
     display: flex;
     padding:48px 30px 0;
     flex-wrap: wrap;
     align-items: center ;
     justify-content: space-between;
     li{
      background: linear-gradient( 180deg, rgba(241,248,255,0) 0%, #DFEFFF 100%);
      border-radius: 32px;
      width: 330px;
      
      box-sizing: border-box ;
      text-align: center;
      margin-bottom: 16px ;
      padding: 32px 0 40px;
      img{
        width:116px;
      }
      h1{
        font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 26px;
color: #0274E5;
line-height: 36px;
text-align: center;
font-style: normal;
margin: 24px auto 8px;
      }
      p{
        font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 22px;
color: #3B546C;
line-height: 36px;
text-align: center;
font-style: normal;
      }
     }
     .last{
        background: none;
      border-radius: 0;
      padding: 0;
      img{
        width: 320px;
        position: relative;
        top: 18px;
      }
     }
  }
}
</style>
